export const LFO_PAIR_LIST = ['tct_lfo_orig', 'tct_lfo_dmg'];
export const LFI_PAIR_LIST = ['tct_lfi_orig', 'tct_lfi_dmg'];
export const RFO_PAIR_LIST = ['tct_rfo_orig', 'tct_rfo_dmg'];
export const RFI_PAIR_LIST = ['tct_rfi_orig', 'tct_rfi_dmg'];
export const LRO_PAIR_LIST = ['tct_lro_orig', 'tct_lro_dmg'];
export const LRI_PAIR_LIST = ['tct_lri_orig', 'tct_lri_dmg'];
export const RRO_PAIR_LIST = ['tct_rro_orig', 'tct_rro_dmg'];
export const RRI_PAIR_LIST = ['tct_rri_orig', 'tct_rri_dmg'];
